// removed by extract-text-webpack-plugin
module.exports = {"container":"Main__container___qOZRP","split":"Main__split___1w3D_","date":"Main__date____ovi1","description":"Main__description___2ZS6q"};


//////////////////
// WEBPACK FOOTER
// ./src/components/Main/Main.css
// module id = 133
// module chunks = 0